<template>
  <div class="lottery">
    <div class="lottery-container">
      <div style="min-height: 1060px" v-loading="loading">
        <div v-if="lotteryList.length" style="padding: 0 40px">
          <div class="item-content" v-for="(item, index) in lotteryList" :key="index">
            <div class="content">
              活动名称： <span>{{ item.activityName }}</span>
            </div>
            <div class="content">
              奖品类别：
              <span>{{ equityGrade(item.equityGrade) }}</span>
              {{ item.equityName }}
            </div>
            <div class="content">
              中奖时间： <span>{{ dateFormate(new Date(item.drawTime)) }}</span>
            </div>
            <div
              class="position-btn"
              v-if="(item.equityType == 5 || item.equityType == 3) && item.ifNeedAddress !== false"
              @click="perfectAddress(item.equityType, item.activityId, item.id, item.extInfo)"
            >
              完善并查看详情
            </div>
          </div>
        </div>
        <WithoutData v-else-if="!loading" />
      </div>
    </div>
    <div class="page">
      <el-pagination
        v-show="totalCount > pageSize"
        :pageSize="pageSize"
        :pageCount="pageSize"
        layout=" prev, pager, next, jumper"
        @current-change="pageChange"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import WithoutData from '@/components/common/WithoutData'
import { dateFormate, getStorage } from '@/lib/utils'
import queryInfo from '@/api/order'
import lottery from '@/api/lottery'
export default {
  name: 'lotteryRecord',
  components: {
    WithoutData
  },
  data() {
    return {
      dateFormate,
      lottery,
      totalCount: 0,
      pageNo: 1,
      pageSize: 8,
      loading: false,
      lotteryList: [],
      lotteryType: ['一等奖', '二等奖', '三等奖', '四等奖', '五等奖', '六等奖', '七等奖', '八等奖']
    }
  },
  created() {
    this.getlottery()
  },
  methods: {
    /**
     * @descripttion: 完善并查看详情
     * @Author: wanght
     * @Date: 2021-05-21 11:12:35
     * @param {equityType}  礼品类型
     * @param {activityId}  活动id
     * @param {id}  礼品id
     * @param {extInfo}  外部礼品:收货地址 / 精品:订单id / 卡券红包:equityExt
     * @return {void}
     */
    perfectAddress(equityType, activityId, id, extInfo) {
      // 获取域名
      const storeDomain = getStorage('domain')
      // equityType 3 表示外部礼品 5 表示精品
      if (equityType === 3) {
        // 外部礼品地址填写页
        window.location.href =
          extInfo == null
            ? `${storeDomain.DOMAIN.activity2c}/receivingaddress?activityId=${activityId}&id=${id}`
            : `${storeDomain.DOMAIN.activity2c}/receivingaddress?activityId=${activityId}&id=${id}&ifNeedAddress=true`
      } else if (equityType === 5) {
        // 订单详情接口，判断是否提交订单
        queryInfo.getDetail({ orderId: extInfo }).then((res) => {
          if (res.data.order.status === 80) {
            this.$router.push({ name: 'order-confirm', params: { orderId: extInfo } }) // 商城下单页
          } else {
            this.$router.push(`/personCenter/orderDetail?id=${extInfo}`) // 订单详情页
          }
        })
      }
    },
    /**
     * @descripttion: 奖品等级
     * @Author: cuiyuan
     * @Date: 2021-05-13 13:31:51
     * @param {number} index [奖品等级]
     * @return {void}
     */
    equityGrade(index) {
      return this.lotteryType[index - 1]
    },
    // 页码切换
    pageChange(pageNo) {
      this.pageNo = pageNo
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      this.getlottery()
    },
    /**
     * @descripttion: 获取中奖记录
     * @Author: cuiyuan
     * @Date: 2021-05-13 15:16:43
     * @param {*}
     * @return {*}
     */
    getlottery() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      lottery.getLottery(params).then((res) => {
        if (res.status === 200) {
          const { total, data } = res.data
          this.totalCount = Number(total)
          this.lotteryList = data
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.lottery-container {
  width: 100%;
  background: #fff;
  box-shadow: 0 1px 5px 1px rgba(224, 224, 224, 0.5);
  .item-content {
    position: relative;
    padding: 20px 0 20px 0;
    border-bottom: 1px solid #eee;
    .content {
      font-size: 16px;
      line-height: 30px;
      color: #000;
    }
    .position-btn {
      position: absolute;
      top: 25px;
      right: 0;
      background-color: #c6001f;
      color: #fff;
      // width: 105rpx;
      padding: 5px 10px;
      text-align: center;
    }
  }
}
.page {
  height: 32px;
  background: #f9f9f9;
  // position: relative;
  display: flex;
  justify-content: center;
  margin: 40px auto 50px;
}
</style>
